import React, { useMemo, useState, useEffect, useRef } from "react";
import objectPath from "object-path";
// LayoutContext
import { useHtmlClassService } from "../_core/MetronicLayout";
// Import Layout components
import { HeaderMobile } from "./header-mobile/HeaderMobile";
import { Aside } from "./aside/Aside";
import { Footer } from "./footer/Footer";
import { LayoutInit } from "./LayoutInit";
import SubHeader from "./subheader/SubHeader";
import QuickPanel from "./extras/offcanvas/QuickPanel";
import QuickUser from "./extras/offcanvas/QuickUser";
import { QuickSearch } from "./extras/offcanvas/QuickSearch";
import { QuickNotification } from "./extras/offcanvas/QuickNotification";
import QuickActions from "./extras/offcanvas/QuickActions";
import { ScrollTop } from "./extras/ScrollTop";
import { StickyToolbar } from "./extras/StickyToolbar";
import { AnimateLoading } from "../../_partials/controls";
import { connect } from 'react-redux';
import { HubConnectionBuilder } from '@microsoft/signalr';
import moment from 'moment';
import constants from "../../../constants/constants";
import * as notificationService from "../../../services/notification/notificationService";
import * as hubConnection from "../../../redux/hubConnectionRedux";
import cogoToast from 'cogo-toast';

const Layout = (props) => {
  const { auth, children, addConnectionHub } = props;
  const [connection, setConnection] = useState(null);
  const [notifications, setNotifications] = useState([]);

  const latestNotifications = useRef();

  latestNotifications.current = notifications;

  useEffect(() => {
    if (auth) {
      const newConnection = new HubConnectionBuilder()
        .withUrl(constants.API_URL + 'hubs/notification', {
          accessTokenFactory: () => auth.authToken
        }).withAutomaticReconnect()
        .build();

      setConnection(newConnection);

      addConnectionHub(newConnection);
      //get old notifications
      fetchNotifications();
    }
  }, [auth]);

  useEffect(() => {
    if (connection) {
      connection.start()
        .then(result => {
          console.log("Notification Connected!");
          connection.on('Notification/' + auth.user.id, notification => {
            cogoToast.info(
              <div>
                <b>Notification!</b>
                <div>{notification.message}</div>
              </div>
              , {
                position: 'top-center',
                hideAfter: 5
              });
            setNotifications([notification, ...latestNotifications.current]);
          });
        }).catch(ex => console.log("Connection failed ", ex));
    }
  }, [connection])

  const fetchNotifications = () => {
    notificationService.getNotification(false).then(res => {
      setNotifications(res);
    })
  }

  const removeNotification = (notificationId) => {
    notificationService.archiveNotification(notificationId).then(res => {
      fetchNotifications();
    }).catch(ex => {
      console.log(ex);
    })
  }

  const uiService = useHtmlClassService();
  // Layout settings (cssClasses/cssAttributes)
  const layoutProps = useMemo(() => {
    return {
      selfLayout: objectPath.get(uiService.config, "self.layout"),
      subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
      contentCssClasses: uiService.getClasses("content", true),
      contentContainerClasses: uiService.getClasses("content_container", true),
      contentExtended: objectPath.get(uiService.config, "content.extended"),
    };
  }, [uiService]);

  return layoutProps.selfLayout !== "blank" ? (
    <>
      {/*begin::Main*/}
      <HeaderMobile />

      <div className="d-flex flex-column flex-root">
        {/*begin::Page*/}
        <div className="d-flex flex-row flex-column-fluid page">
          <Aside notifications={notifications} />

          {/*begin::Wrapper*/}
          <div
            className="d-flex flex-column flex-row-fluid wrapper"
            id="kt_wrapper"
          >
            {/*begin::Content*/}
            <div
              id="kt_content"
              className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
            >
              <AnimateLoading />
              {/* {layoutProps.subheaderDisplay && <SubHeader />} */}

              {/*begin::Entry*/}
              {layoutProps.contentExtended && <>{children}</>}

              {!layoutProps.contentExtended && (
                <div className="d-flex flex-column-fluid mt-10">
                  {/*begin::Container*/}
                  <div className={layoutProps.contentContainerClasses}>
                    {children}
                  </div>
                  {/*end::Container*/}
                </div>
              )}

              {/*end::Entry*/}
            </div>
            {/*end::Content*/}
            {/* <Footer /> */}
          </div>
          {/*end::Wrapper*/}
        </div>
        {/*end::Page*/}
      </div>
      <QuickUser />
      <QuickPanel
        removeNotification={removeNotification}
        notifications={notifications}
        setNotifications={setNotifications}
      />
      <QuickNotification />
      <ScrollTop />
      <QuickSearch />
      <QuickActions />
      {/* <StickyToolbar /> */}
      {/*end::Main*/}
      <LayoutInit />
    </>
  ) : (
    // BLANK LAYOUT
    <div className="d-flex flex-column flex-root">{children}</div>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  hubConnection: state.hub
})

export default connect(mapStateToProps, hubConnection.actions)(Layout);
